import {
  LOG_IN_REQUEST,
  LOG_IN_SUCCESS,
  LOG_IN_FAILURE,
  LOG_OUT_REQUEST,
  LOG_OUT_SUCCESS,
  LOG_OUT_FAILURE,
  SIGN_UP_SUCCESS,
  HTTP_401_UNAUTHORIZED,
  SAML_AUTHENTICATED,
  DISABLE_SIGNIN,
  ENABLE_SIGNIN,
} from '../../constants/ActionTypes'

import * as moment from 'moment';

const isLoggedIn = () => {
  if (localStorage.hasOwnProperty('user')) {
    let loginTime = new Date(JSON.parse(localStorage.getItem('user')).loginTime);
    const maxLoggedInHours = 2;
    return moment.duration(new Date() - loginTime).hours() < maxLoggedInHours;
  }
  return false;
}

const initialState = {
  loggingIn: false,
  loggedIn: isLoggedIn(),
  isDisableSignin: false,
  user: {},
  error: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOG_IN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        loggedIn: false,
        error: {}, //clear errors
        user: {},
      };
    case LOG_IN_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        error: {}, //clear errors
        user: { ...action.payload.user },
      };
    case LOG_IN_FAILURE: {
      let error = {};
      error.email = '';
      error.password = action.payload.error.message;
      return {
        ...state,
        loggingIn: false,
        loggedIn: false,
        user: {},
        error: error,
      }
    }
    case LOG_OUT_REQUEST:
      return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        error: {}, //clear errors
        user: {},
      };
    case LOG_OUT_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        loggedIn: false,
        error: {}, //clear errors
        user: {},
      };
    case LOG_OUT_FAILURE:
      return {
        ...state,
        loggingIn: false,
        loggedIn: false,
        user: {},
        error: action.payload.error,
      }
    case SIGN_UP_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        error: {}, //clear errors
        user: {},
      };
    case HTTP_401_UNAUTHORIZED:
      return {
        ...state,
        loggedIn: false,
        error: action.payload.error,
      }
    case SAML_AUTHENTICATED:
      return {
        loggingIn: false,
        loggedIn: true,
        error: {}, //clear errors
        user: {},
      };
    case DISABLE_SIGNIN:
      return {
        ...state,
        isDisableSignin: true,
      }
    case ENABLE_SIGNIN:
      return {
        ...state,
        isDisableSignin: false,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/signin.js